"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Debug;
    }
});
const _boxen = /*#__PURE__*/ _interop_require_default(require("boxen"));
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _safe = /*#__PURE__*/ _interop_require_default(require("colors/safe"));
const _DebugMgr = /*#__PURE__*/ _interop_require_default(require("./DebugMgr"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const yellowBold = (str)=>_safe.default.yellow(_safe.default.bold(str));
const redBold = (str)=>_safe.default.red(_safe.default.bold(str));
let Debug = class Debug {
    ppException(e, func = null) {
        let log = '';
        log += `                                              EXCEPTION OCCURED!! in ${redBold(this.namespace)} @ ${func}`;
        log += redBold('\n- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -\n');
        log += yellowBold(`MESSAGE:\n`);
        log += yellowBold(`${e.message}\n`);
        log += redBold('\n- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -\n');
        log += yellowBold(`CODE:\n`);
        log += yellowBold(`${e.code}\n`);
        log += redBold('\n- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -\n');
        log += yellowBold(`STACK:\n`);
        log += yellowBold(`${e.stack}\n`);
        log += redBold('\n- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -\n');
        console.log((0, _boxen.default)(log, {
            padding: 1,
            borderStyle: 'double'
        }));
        console.log(e);
        return log;
    }
    ppe(e, func) {
        return this.ppException(e, func);
    }
    constructor(namespace){
        this.namespace = namespace;
        this.api = (0, _debug.default)(`${namespace}_A`);
        this.warn = (0, _debug.default)(`${namespace}_W`);
        this.info = (0, _debug.default)(`${namespace}_I`);
        this.error = (0, _debug.default)(`${namespace}_E`);
        this.debug = (0, _debug.default)(`${namespace}_D`);
        _DebugMgr.default.createNamespace(namespace);
    }
};
